import { HOME_FAQ_ITEMS, HOME_FEATURED_ARTICLE_SLUGS } from './homeContent';
import {
  CLINIC_SCHEMA,
  DEFAULT_OG_IMAGE,
  ORGANIZATION_ID,
  SITE_NAME,
  SITE_URL,
  WEBSITE_ID,
  articleUrl,
} from './seo';

export const MEDICAL_CLINIC_ID = `${SITE_URL}/#medicalclinic`;
export const HOME_FAQ_ID = `${SITE_URL}/#faq`;
export const HOME_FEATURED_ARTICLES_ID = `${SITE_URL}/#featured-articles`;

export function buildHomeFaqSchemaNode() {
  return {
    '@type': 'FAQPage',
    '@id': HOME_FAQ_ID,
    mainEntity: HOME_FAQ_ITEMS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function buildHomeFeaturedArticlesItemListNode() {
  return {
    '@type': 'ItemList',
    '@id': HOME_FEATURED_ARTICLES_ID,
    name: 'Dental Health Tips & Articles',
    itemListElement: HOME_FEATURED_ARTICLE_SLUGS.map((slug, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: articleUrl(slug),
    })),
  };
}

export function buildHomePageSchemaGraph() {
  const hoursSpec = CLINIC_SCHEMA.openingHours.map((spec) => ({
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: spec.dayOfWeek,
    opens: spec.opens,
    closes: spec.closes,
  }));

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': ORGANIZATION_ID,
        name: CLINIC_SCHEMA.name,
        alternateName: CLINIC_SCHEMA.alternateName,
        url: SITE_URL,
        logo: {
          '@type': 'ImageObject',
          url: DEFAULT_OG_IMAGE,
          width: 192,
          height: 192,
        },
        image: CLINIC_SCHEMA.image,
        telephone: CLINIC_SCHEMA.telephone,
        email: CLINIC_SCHEMA.email,
        sameAs: CLINIC_SCHEMA.sameAs,
      },
      {
        '@type': ['MedicalClinic', 'DentalClinic', 'Dentist', 'LocalBusiness'],
        '@id': MEDICAL_CLINIC_ID,
        name: CLINIC_SCHEMA.name,
        alternateName: CLINIC_SCHEMA.alternateName,
        image: CLINIC_SCHEMA.image,
        url: SITE_URL,
        telephone: CLINIC_SCHEMA.telephone,
        email: CLINIC_SCHEMA.email,
        parentOrganization: { '@id': ORGANIZATION_ID },
        address: {
          '@type': 'PostalAddress',
          streetAddress: CLINIC_SCHEMA.address.streetAddress,
          addressLocality: CLINIC_SCHEMA.address.addressLocality,
          addressRegion: CLINIC_SCHEMA.address.addressRegion,
          postalCode: CLINIC_SCHEMA.address.postalCode,
          addressCountry: CLINIC_SCHEMA.address.addressCountry,
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: CLINIC_SCHEMA.geo.latitude,
          longitude: CLINIC_SCHEMA.geo.longitude,
        },
        openingHoursSpecification: hoursSpec,
        description: CLINIC_SCHEMA.description,
        priceRange: CLINIC_SCHEMA.priceRange,
        sameAs: CLINIC_SCHEMA.sameAs,
        areaServed: [
          { '@type': 'City', name: 'Lalitpur' },
          { '@type': 'City', name: 'Kathmandu' },
          { '@type': 'City', name: 'Patan' },
        ],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Dental Services',
          itemListElement: [
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Teeth Cleaning & Scaling' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Dental Implants' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Orthodontics & Braces' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Root Canal Treatment' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Teeth Whitening' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Emergency Dental Care' } },
          ],
        },
      },
      {
        '@type': 'WebSite',
        '@id': WEBSITE_ID,
        url: SITE_URL,
        name: SITE_NAME,
        description: CLINIC_SCHEMA.description,
        publisher: { '@id': ORGANIZATION_ID },
        inLanguage: 'en',
      },
      buildHomeFaqSchemaNode(),
      buildHomeFeaturedArticlesItemListNode(),
    ],
  };
}

/** @deprecated Use buildHomePageSchemaGraph — FAQ is included in the homepage @graph */
export function buildHomeFaqSchema() {
  return {
    '@context': 'https://schema.org',
    ...buildHomeFaqSchemaNode(),
  };
}
